// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"5439de64","977":"4fc56bba"}[chunkId] + ".chunk.js";
};